import Serializable from "Serializable";
import RiSubCategoryType from "../../../../../../Constants/RiSubCategoryType.js";
import AnnotationSettings from "../AnnotationSettings.js";
import RiPanelOneilListSettings from "./RiPanelOneilListSettings.js";
import RiPanelNewSettings from "./RiPanelNewSettings.js";
import RiPanelAiSettings from "./RiPanelAiSettings.js";

class RiPanelETFViewSettings extends Serializable {

    getDefaulSettings() {
        this.ActiveSelectedSubCategory = RiSubCategoryType.News;
        this.AnnotationSettings = this.getDefaultAnnotationSettings();
        this.OneilListSettings = this.getDefaultOneilListSettings();
        this.NewSettings = this.getDefaultNewsSettings();
        this.AiSettings = this.getDefaultAiSettings();
        return this;
    }

    onSeralisedInfoRecieved(serializedValue) {
        this.ActiveSelectedSubCategory = serializedValue.ActiveSelectedSubCategory ? serializedValue.ActiveSelectedSubCategory : RiSubCategoryType.News;
        this.AnnotationSettings = serializedValue.AnnotationSettings ? serializedValue.AnnotationSettings : this.getDefaultAnnotationSettings();
        this.OneilListSettings = serializedValue.OneilListSettings ? serializedValue.OneilListSettings : this.getDefaultOneilListSettings();
        this.NewSettings = serializedValue.NewSettings ? serializedValue.NewSettings : this.getDefaultNewsSettings();
        this.AiSettings = serializedValue.AiSettings ? serializedValue.AiSettings : this.getDefaultAiSettings();
    }

    getObjectMapKey() {
        return "RiPanelETFViewSettings";
    }

    getDataObject() {
        return {
            ActiveSelectedSubCategory: this.ActiveSelectedSubCategory,
            AnnotationSettings: this.AnnotationSettings,
            OneilListSettings: this.OneilListSettings,
            NewSettings: this.NewSettings,
            AiSettings: this.AiSettings
        };
    }

    getDefaultAnnotationSettings() {
        const annotationSettings = new AnnotationSettings();
        return annotationSettings;
    }

    getDefaultOneilListSettings() {
        const oneilListSettings = new RiPanelOneilListSettings();
        return oneilListSettings;
    }

    getDefaultNewsSettings() {
        const newsSettings = new RiPanelNewSettings();
        return newsSettings;
    }

    getDefaultAiSettings() {
        const aiSettings = new RiPanelAiSettings();
        return aiSettings;
    }

}


export default RiPanelETFViewSettings;